// Payment of the psychotherapy variant: the onboarding's own SEPA step with its
// opt-out, unchanged (Paul, 2026-10-29: "the same SEPA explanation screen").
// Opting out = invoice: payment_method `rechnung`, otherwise `sepa`.
//
// Order matters (incident 2026-10-09, the SEPA restart loop): the submission
// (new patients only) and the psychotherapy case are stored FIRST; only then
// may the patient leave for the mandate page. Whatever happens there, nothing
// is lost and nothing is signed twice.
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { Step11SepaDebit } from '../Step11SepaDebit'
import { useOnboardingStore } from '../../store/onboardingStore'
import { completePtCase } from '../../flow/ptComplete'
import type { StepProps } from '../../types'

export function PtPaymentStep({ onNext, onBack }: StepProps) {
  const { t } = useTranslation()
  const cohort = useOnboardingStore(s => s.cohort)
  // Back from the mandate page with the case already filed: the standard "set up now / later" choice.
  // Read on arrival only, like the standard step's submission check — not when the case completes here.
  const [completedBefore] = useState(() => useOnboardingStore.getState().ptCompleted)

  const completeCase = async (optOut: boolean): Promise<boolean> => {
    const result = await completePtCase(optOut ? 'rechnung' : 'sepa')
    if (result === 'not_signed') { toast.error(t('pt.payment.notSigned')); return false }
    if (result === 'incomplete') { toast.error(t('pt.payment.incomplete')); return false }
    // Stored on our side; the case worker and the final screen try again
    if (result === 'error') toast.error(t('pt.payment.completeFailed'), { duration: 10000 })
    return true
  }

  // Returning patients completed their onboarding submission before — no second one
  return <Step11SepaDebit onNext={onNext} onBack={onBack} createSubmission={cohort === 'psychotherapy'} beforeMandate={completeCase} alreadyStored={completedBefore} />
}
